import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const UserProfileAdd2 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20, strokeWidth = 1.5 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M18.2291 10C18.2291 9.25369 18.1298 8.53057 17.9436 7.84316C16.9959 4.34448 13.7985 1.77083 9.99994 1.77083C5.45508 1.77083 1.77075 5.45516 1.77075 10C1.77075 14.5449 5.45508 18.2292 9.99994 18.2292M10 12.143C7.06872 12.143 4.93154 13.4843 3.57089 15.1521"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d="M18.8021 15.0087H15.0521M15.0521 15.0087H11.3021M15.0521 15.0087V18.7585M15.0521 15.0087V11.2585"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0639 6.90872C12.0639 5.8094 11.1358 4.91119 9.99994 4.91119C8.86409 4.91119 7.93604 5.8094 7.93604 6.90872C7.93604 8.00804 8.86409 8.90625 9.99994 8.90625C11.1358 8.90625 12.0639 8.00804 12.0639 6.90872Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    )
  },
)

export default UserProfileAdd2
